import type { BookDetails } from '@package/api'
import type { RenderLink } from '@ui/web/utils'

import type { CardAction } from '../../components/cards/card-action'
import type { LessonModuleModalData } from '../../components/lesson-module-modal'

export type FavoriteTab = 'buku' | 'koleksi-bacaan' | 'latihan-dan-kuis' | 'proyek-dan-tugas'

export const FAVORITE_TABS: FavoriteTab[] = ['buku', 'koleksi-bacaan', 'latihan-dan-kuis', 'proyek-dan-tugas']

export interface FavoritePageProps {
  tab: FavoriteTab
  search: string
  onTabChange: (tab: FavoriteTab) => void
  onSearchChange: (q: string) => void
  renderBookModalAction: (book: BookDetails) => CardAction
  renderLessonModuleModalAction: (module: LessonModuleModalData) => CardAction
  renderCollectionAction: (meta: { id: string; slug: string }) => CardAction
  renderCollectionLink?: RenderLink
  renderLoveBookLink?: RenderLink
  renderExplorePage: RenderLink
  renderSearchPage: RenderLink
  className?: string
}
